<template>
  <v-dialog
    v-model="dialog"
    max-width="500"
    persistent
  >
    <v-card>

      <v-card-title>
        {{ title }}
      </v-card-title>

      <v-card-text>

        <v-row>

          <v-col cols="12" md="6">

            <v-menu
              ref="menuFrom"
              v-model="menuFrom"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290"
            >

              <template v-slot:activator="{ on, attrs }">

                <v-text-field
                  v-model="from"
                  label="Fecha inicial"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                />

              </template>

              <v-date-picker
                v-model="from"
                @input="menuFrom = false"
              />

            </v-menu>

          </v-col>

          <v-col cols="12" md="6">

            <v-menu
              ref="menuTo"
              v-model="menuTo"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290"
            >

              <template v-slot:activator="{ on, attrs }">

                <v-text-field
                  v-model="to"
                  label="Fecha final"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                />

              </template>

              <v-date-picker
                v-model="to"
                @input="menuTo = false"
              />

            </v-menu>

          </v-col>

        </v-row>

      </v-card-text>

      <v-divider/>

      <v-card-actions>

        <v-spacer/>

        <v-btn
          text
          color="grey"
          @click="close"
        >
          Cancelar
        </v-btn>

        <v-btn
          style="
                    background-color: rgb(204 33 40);
                    color: white !important;
                  "

          :disabled="!from || !to"
          @click="download"
        >
          Exportar
        </v-btn>

      </v-card-actions>

    </v-card>

  </v-dialog>
</template>

<script>

export default {

  props: {

    value: {
      type: Boolean,
      default: false,
    },

    company: {
      type: Object,
      default: null,
    },

    type: {
      type: String,
      default: null,
    },

  },

  data () {

    return {

      menuFrom: false,

      menuTo: false,

      from: null,

      to: null,

    }

  },

  computed: {

    dialog: {

      get () {

        return this.value

      },

      set (value) {

        this.$emit(
          'input',
          value,
        )

      },

    },

    title () {

      return this.type === 'logs'
        ? 'Exportar logs'
        : 'Exportar reporte'

    },

  },

  methods: {

    close () {

      this.from = ''
      this.to = ''
      this.menuFrom = false
      this.menuTo = false
      this.dialog = false

    },

    download () {

      this.$emit(
        'download',
        {

          company: this.company,

          from: this.from,

          to: this.to,

          type: this.type,

        },
      )

      this.close()

    },

  },

}

</script>
